import { render } from "./EditProfileSocials.vue?vue&type=template&id=03808f39&scoped=true"
import script from "./EditProfileSocials.vue?vue&type=script&lang=js"
export * from "./EditProfileSocials.vue?vue&type=script&lang=js"

import "./EditProfileSocials.vue?vue&type=style&index=0&id=03808f39&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03808f39"]])

export default __exports__